// router/index.js
import { createRouter, createWebHistory } from "vue-router";
import { useUserStore } from "@/store/index.js";

// 通用组件
import Login from "@/view/Login.vue";
import MainLayout from "@/view/MainLayout.vue";
import MobileLayout from "@/view/MobileLayout.vue";
// 基础路由
const routes = [
    {
        path: "/",
        redirect: "/login",
        meta: { title: "心鉴智愈" },
    },
    {
        path: "/login",
        name: "Login",
        meta: { title: "心鉴智愈" },
        component: Login,
    },
    {
        path: "/",
        component: MainLayout,
        meta: { requiresAuth: true },
        children: [
            {
                path: "/eeg-record",
                name: "EEGRecord",
                component: () => {
                    return new Promise((resolve) => {
                        const userStore = useUserStore();
                        if (userStore.role === "patient") {
                            import("@/view/ForPatient/EEGRecord.vue").then(
                                resolve
                            );
                        } else {
                            import("@/view/ForDoctor/EEGRecord.vue").then(
                                resolve
                            );
                        }
                    });
                },
                meta: {
                    title: "脑电信号上传",
                },
            },
            {
                path: "/depression-report",
                name: "DepressionReport",
                component: () => {
                    const userStore = useUserStore();
                    return userStore.role === "patient"
                        ? import("@/view/ForDoctor/DepressionReport.vue")
                        : import("@/view/ForDoctor/DepressionReport.vue");
                },
                meta: {
                    title: "诊断报告",
                },
            },
            {
                path: "/sleep-report",
                name: "SleepReport",
                component: () => {
                    const userStore = useUserStore();
                    return userStore.role === "patient"
                        ? import("@/view/ForPatient/SleepReport.vue")
                        : import("@/view/ForDoctor/SleepReport.vue");
                },
                meta: {
                    title: "诊断报告",
                },
            },
            {
                path: "/ai",
                name: "AI",
                component: () => {
                    const userStore = useUserStore();
                    return userStore.role === "patient"
                        ? import("@/view/ForPatient/Ai.vue")
                        : import("@/view/ForDoctor/Ai.vue");
                },
                meta: {
                    title: () => {
                        const userStore = useUserStore();
                        userStore.role === "patient"
                            ? "失眠陪伴助手"
                            : "脑电智能助手";
                    },
                },
            },
            {
                path: "/reference",
                name: "Reference",
                component: () => {
                    const userStore = useUserStore();
                    return userStore.role === "patient"
                        ? import("@/view/ForPatient/Reference.vue")
                        : import("@/view/ForDoctor/Reference.vue");
                },
                meta: {
                    title: "指标参考",
                },
            },
            {
                path: "/account-settings",
                name: "AccountSettings",
                component: () => {
                    const userStore = useUserStore();
                    return userStore.role === "patient"
                        ? import("@/view/ForPatient/AccountSettings.vue")
                        : import("@/view/ForDoctor/AccountSettings.vue");
                },
                meta: {
                    title: "账户设置",
                },
            },
            // 睡眠改善方案相关路由 - 暂时隐藏，保留代码
            // {
            //     path: "/treatment-plan",
            //     name: "TreatmentPlan",
            //     component: () => import("@/view/ForDoctor/TreatmentPlan.vue"),
            //     meta: {
            //         title: "睡眠改善方案编辑",
            //         requiresAuth: true,
            //     },
            // },
            {
                path: "/light-therapy",
                name: "LightTherapy",
                component: () => import("@/view/ForDoctor/LightTherapy.vue"),
                meta: {
                    title: "脑机智能疗愈灯",
                    requiresAuth: true,
                },
            },
            // {
            //     path: "/treatment-plan-management",
            //     name: "TreatmentPlanManagement",
            //     component: () =>
            //         import("@/view/ForDoctor/TreatmentPlanManagement.vue"),
            //     meta: {
            //         title: "睡眠改善方案管理",
            //         requiresAuth: true,
            //     },
            // },
            // 问卷管理相关路由
            {
                path: "/questionnaire-management",
                name: "QuestionnaireManagement",
                component: () => import("@/view/ForDoctor/QuestionnaireManagement.vue"),
                meta: {
                    title: "问卷管理",
                    requiresAuth: true
                },
            },
            {
                path: "/questionnaire-detail",
                name: "QuestionnaireDetail",
                component: () => import("@/view/ForDoctor/QuestionnaireDetail.vue"),
                meta: {
                    title: "问卷详情",
                    requiresAuth: true
                },
            },
            {
                path: "/patient/:id",
                name: "Patient",
                component: () => {
                    const userStore = useUserStore();
                    return userStore.role === "patient"
                        ? import("@/view/ForPatient/Patient.vue")
                        : import("@/view/ForDoctor/Patient.vue");
                },
                props: true,
                meta: {
                    title: "病人详情",
                },
                beforeEnter: (to, from, next) => {
                    const userStore = useUserStore();
                    if (!userStore.role) {
                        console.log("进入患者页面，ID:", to.params.id);
                        next();
                    } else {
                        console.error("身份非法：", userStore.role);
                        next();
                    }
                },
            },
        ],
    },
    {
        path: "/m",
        component: MobileLayout,
        meta: { requiresAuth: true },
        children: [
            {
                path: "main",
                name: "MobileMain",
                component: () =>
                    import("@/view/ForPatient/mobile/IndexMain.vue"),
                meta: { requiresAuth: true, title: "首页" },
            },
            {
                path: "report",
                name: "MobileReport",
                component: () =>
                    import("@/view/ForPatient/mobile/IndexReport.vue"),
                meta: { requiresAuth: true, title: "报告" },
            },
            {
                path: "sleep-data",
                name: "MobileSleepData",
                component: () =>
                    import("@/view/ForPatient/mobile/SleepData.vue"),
                meta: { requiresAuth: true, title: "睡眠数据" },
            },
            {
                path: "ai",
                name: "MobileAi",
                component: () => import("@/view/ForPatient/mobile/IndexAi.vue"),
                meta: { requiresAuth: true, title: "解忧" },
            },
            {
                path: "more",
                name: "MobileMore",
                component: () =>
                    import("@/view/ForPatient/mobile/IndexMore.vue"),
                meta: { requiresAuth: true, title: "更多" },
            },
            {
                path: "my",
                name: "My",
                component: () => import("@/view/ForPatient/mobile/My.vue"),
                meta: { requiresAuth: true, title: "我的" },
            },
            {
                path: "sleep-report",
                name: "MobileSleepReport",
                component: () => import("@/view/ForPatient/mobile/Report.vue"),
                meta: { requiresAuth: true, title: "睡眠报告" },
            },
            {
                path: "account-settings",
                name: "MobileAccountSettings",
                component: () => 
                    import("@/view/ForPatient/AccountSettings.vue")
                ,
                meta: { requiresAuth: true, title: "账户设置" },
            },
            {
                path: "reference",
                name: "MobileReference",
                component: () => {
                    const userStore = useUserStore();
                    return userStore.role === "patient"
                        ? import("@/view/ForPatient/Reference.vue")
                        : import("@/view/ForDoctor/Reference.vue");
                },
                meta: {
                    requiresAuth: true,
                    title: "指标参考",
                },
            },
            // 暂时隐藏患者端改善方案页面路由
            // {
            //     path: "treatment-flow",
            //     name: "MobileTreatmentFlow",
            //     component: () =>
            //         import("@/view/ForPatient/mobile/TreatmentFlow.vue"),
            //     meta: {
            //         requiresAuth: true,
            //         title: "治疗流程",
            //     },
            // },
            {
                path: "depression-assessment",
                name: "DepressionAssessment",
                component: () =>
                    import("@/view/ForPatient/mobile/DepressionAssessment.vue"),
                meta: {
                    requiresAuth: true,
                    title: "自我抑郁量表测评",
                },
            },
            {
                path: "assessment-detail/:id",
                name: "AssessmentDetail",
                component: () =>
                    import("@/view/ForPatient/mobile/AssessmentDetail.vue"),
                meta: {
                    requiresAuth: true,
                    title: "量表详情",
                },
            },
            {
                path: "assessment-quiz/:id",
                name: "AssessmentQuiz",
                component: () =>
                    import("@/view/ForPatient/mobile/AssessmentQuiz.vue"),
                meta: {
                    requiresAuth: true,
                    title: "开始测评",
                },
            },
            {
                path: "assessment-result/:id",
                name: "AssessmentResult",
                component: () =>
                    import("@/view/ForPatient/mobile/AssessmentResult.vue"),
                meta: {
                    requiresAuth: true,
                    title: "测评结果",
                },
            },
            {
                path: "light-therapy",
                name: "MobileLightTherapy",
                component: () =>
                    import("@/view/ForPatient/mobile/LightTherapy.vue"),
                meta: {
                    requiresAuth: true,
                    title: "疗愈灯",
                },
            },
            {
                path: "questionnaire-detail",
                name: "MobileQuestionnaireDetail",
                component: () => import("@/view/ForPatient/mobile/QuestionnaireDetail.vue"),
                meta: {
                    requiresAuth: true,
                    title: "问卷详情",
                },
            },
        ]
    },
    // 404页面
    {
        path: "/:pathMatch(.*)*",
        redirect: "/login",
    },
];

const router = createRouter({
    // 路由基础路径：由 vue.config.js 通过 DefinePlugin 注入，构建时可覆盖（子路径部署），默认 "/"
    history: createWebHistory(process.env.ROUTER_BASE || "/"),
    routes,
});
// 判断是否为手机端
function isMobile() {
    return /Mobile|Android|iPhone|iPad|iPod|IEMobile|BlackBerry|Opera Mini/i.test(
        navigator.userAgent
    );
}
// 添加全局前置守卫
router.beforeEach(async (to, from, next) => {
    const userStore = useUserStore();
    // 所有路由不登录不能进入

    // 检查是否已认证
    if (
        to.path !== "/login" &&
        (!userStore.isAuthenticated || userStore.role === "")
    ) {
        console.log("未登录，重定向到登录页");
        return next("/login");
    }
    //手机端引导至/m路径
    console.log("当前路由:", to.path);
    if (isMobile() && userStore.role === "patient" && to.path === "/sleep-report") {
        console.log("前往路由:", "/m" + to.path);

        return next("/m" + to.path);
    }

    console.log("前往路由:", to.path);
    next();
});

export default router;
